<l-list-container
  class="tracks-list-table"
  [size]="limit"
  [page]="page"
  [data]="data"
  [sort]="sort"
  [total]="total"
  [isLoading]="isLoading"
  (onPage)="pageChange.emit($event)"
  (onSort)="sortChange.emit($event)"
>
  <ng-template #header>
    <th lSortable="name">Nome</th>
    <th lSortable="description">Descrição</th>
    <th lSortable="isActive">Status</th>
    <th lSortable="createdAt">Criado em</th>
    <th lSortable="updatedAt">Última atualização</th>
    <th class="w-12"></th>
  </ng-template>

  <ng-template #body let-track>
    <td class="align-top">
      <span class="font-medium text-lWhite">{{ track.name }}</span>
    </td>

    <td class="align-top">
      <span class="block max-w-[460px] text-sm leading-5 text-lGray300">
        {{ track.description || '—' }}
      </span>
    </td>

    <td class="align-top">
      <l-status-pill [status]="getTrackStatus(track)" />
    </td>

    <td class="align-top">{{ track.createdAt ? (track.createdAt | date: 'yyyy-MM-dd') : '—' }}</td>

    <td class="align-top">{{ track.updatedAt ? (track.updatedAt | date: 'yyyy-MM-dd') : '—' }}</td>

    <td class="align-top">
      <button
        class="flex h-7 w-7 items-center justify-center rounded text-lGray600 transition-colors hover:bg-lGray700/70 hover:text-lWhite"
        (click)="rowMenu.toggle($event)"
      >
        <l-icon icon="more_vert" />
      </button>

      <l-modal-actions #rowMenu [actions]="getRowActions(track)" />
    </td>
  </ng-template>
</l-list-container>

